import DocViewShell from "@/components/DocViewShell";
import SipocBlueprint from "@/components/blueprints/SipocBlueprint";

export default function SipocView() {
  return (
    <DocViewShell
      eyebrow="SIPOC Process Map"
      eyebrowClass="text-blue-700"
      toolName="SIPOC Process Map"
      maxWidth="max-w-6xl"
      editPathFn={(id) => `/sipoc/${id}`}
      render={(doc) => <SipocBlueprint doc={doc} />}
    />
  );
}
